// // NPM
// import { lock, unlock } from 'tua-body-scroll-lock';
// import gsap from 'gsap';
// import debounce from 'lodash.debounce'; 




// Initialization
function header() {
    // Constants

    let breakpoint = null;
    let collapseTimeline = null;
    let expandTimeline = null;
    let collapsed = false;
    let mMedia = null;
    let resizing = false;
    let prevScroll = 0;
    let updateDetailsTimeout = null;
    let activeNavTheme = null;


    initBreakpoints();
    initNavToggle();
    initCollapse();
    initExpand();
    // initScroll();
    initResize();
    
    initSubNavDetail();
    updateNavTheme(0);
    initLinks();
}



function reinit(data) {
  const nextHeaderHTML = new DOMParser().parseFromString(data.next.html, 'text/html');
  const nextHeader = nextHeaderHTML.querySelector('.Header');
  if (nextHeader) {
    const theme = nextHeader.getAttribute('data-theme');
    const currentHeader = document.querySelector('.Header');
    if (currentHeader) {
      currentHeader.setAttribute('data-theme', theme);
    }
  }
}

function initLinks() {
  const headerLinks = document.querySelectorAll('.Header a');
  headerLinks.forEach(link => {
    link.addEventListener('click', closeNav);
  });
}

function initBreakpoints() {
  mMedia = gsap.matchMedia();
//   mMedia = 5;
  const tablet = 640;
  const desktop = 1200;

  // Mobile
  mMedia.add(`(max-width: ${tablet - 1}px)`, () => {
    breakpoint = 'mobile';
    resetCollapse();
    initTouchSubNav();
  });

  // Tablet
  mMedia.add(`(min-width: ${tablet}px) and (max-width: ${desktop - 1}px)`, () => {
    breakpoint = 'tablet';
    resetCollapse();
    initTouchSubNav();
  });

  // Desktop
  mMedia.add(`(min-width: ${desktop}px)`, () => {
    breakpoint = 'desktop';
    resetCollapse();
    // onScroll();
    initDesktopSubNav();
  });
}

function initCollapse() {
  const header = document.querySelector('.Header');
  const logo = header ? header.querySelector('.Header-logoLink') : null;
  const nav = header ? header.querySelector('.Header-nav') : null;
  const secondaryLinks = header ? header.querySelectorAll('.Header-secondaryNavItem--link') : [];
  const expand = header ? header.querySelector('.Header-secondaryNavItem--expand') : null;
  const button = header ? header.querySelector('.Header-secondaryNavItem--button') : null;

  const collapsedWidth = button ? button.offsetWidth + 107 : 107;

  collapseTimeline = gsap.timeline({
    paused: true
  });

  if (header) {
    collapseTimeline.set(header, { left: 'auto', width: () => window.innerWidth });
  }
  if (expand) {
    collapseTimeline.set(expand, { opacity: 0, display: 'none' });
  }
  if (logo) {
    collapseTimeline.to(logo, { opacity: 0, display: 'none', duration: 0.1 }, 0);
  }

  if (secondaryLinks.length > 0) {
    collapseTimeline.to(secondaryLinks, { opacity: 0, display: 'none', duration: 0.1 }, 0);
  }

  if (nav) {
    collapseTimeline.to(nav, { opacity: 0, display: 'none', duration: 0.1 }, 0);
  }
  if (header) {
    collapseTimeline.to(header, { width: collapsedWidth, duration: 0.3, ease: 'power4.inOut' });
  }
  if (expand) {
    collapseTimeline.to(expand, { display: 'block', opacity: 1, duration: 0.1 }, '<');
  }
}

function initExpand() {
  const header = document.querySelector('.Header');
  const logo = header ? header.querySelector('.Header-logoLink') : null;
  const nav = header ? header.querySelector('.Header-nav') : null;
  const secondaryLinks = header ? header.querySelectorAll('.Header-secondaryNavItem--link') : [];
  const expand = header ? header.querySelector('.Header-secondaryNavItem--expand') : null;
  const expandButton = header ? header.querySelector('[data-expand-nav]') : null;

  expandTimeline = gsap.timeline({
    paused: true
  });

  if (expand) {
    expandTimeline.to(expand, { display: 'none', opacity: 0, duration: 0.1 });
  }
  if (header) {
    expandTimeline.to(header, { width: () => window.innerWidth, duration: 0.3, ease: 'power4.inOut' }, 0);
  }
  if (nav) {
    expandTimeline.to(nav, { opacity: 1, display: 'block', duration: 0.1 }, 0.3);
  }

  if (secondaryLinks.length > 0) {
    expandTimeline.to(secondaryLinks, { opacity: 1, display: 'block', duration: 0.1 }, 0.3);
  }

  if (logo) {
    expandTimeline.to(logo, { opacity: 1, display: 'block', duration: 0.1 }, 0.3);
  }

  if (expandButton) {
    expandButton.addEventListener('click', (e) => {
      e.preventDefault();
      expandNav();
    });
  }
}

function resetCollapse() {
  collapsed = false;

  const header = document.querySelector('.Header');
  const logo = header ? header.querySelector('.Header-logoLink') : null;
  const secondaryLinks = header ? header.querySelectorAll('.Header-secondaryNavItem--link') : [];
  const expand = header ? header.querySelector('.Header-secondaryNavItem--expand') : null;
  const nav = header ? header.querySelector('.Header-nav') : null;
  const subNav = header ? header.querySelector('.Header-subNav') : null;
  const navSpacer = header ? header.querySelector('.Header-navSpacer') : null;
  const mobileFooterButton = header ? header.querySelector('.Header-mobileFooterButton') : null;

  if (header) {
    header.setAttribute('data-open', 'false');
    header.removeAttribute('style');
  }
  if (logo) {
    logo.removeAttribute('style');
  }
  secondaryLinks.forEach(link => link.removeAttribute('style'));
  if (expand) {
    expand.removeAttribute('style');
  }
  if (nav) {
    nav.removeAttribute('style');
  }
  if (subNav) {
    subNav.removeAttribute('style');
  }
  if (navSpacer) {
    navSpacer.removeAttribute('style');
  }
  if (mobileFooterButton) {
    mobileFooterButton.removeAttribute('style');
  }

  closeToggle();
}

function initNavToggle() {
  const toggleButtons = document.querySelectorAll('[data-toggle-nav]');
  const header = document.querySelector('.Header');

  toggleButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      if (header && header.getAttribute('data-open') === 'true') {
        closeNav();
        return;
      }
      openNav();
    });
  });
}

function initTouchSubNav() {
  const subNavItems = document.querySelectorAll('.Header-navItem--withSubnav');

  subNavItems.forEach(item => {
    const title = item.querySelector('.Header-navLink');
    if (title) {
      title.removeEventListener('click', handleTouchSubNavClick);
      title.addEventListener('click', handleTouchSubNavClick);
    }
    item.removeEventListener('click', handleTouchSubNavItemClick);
    item.addEventListener('click', handleTouchSubNavItemClick);
  });
}

function handleTouchSubNavClick(e) {
  const item = this.closest('.Header-navItem--withSubnav');
  if (!item) return;
  const isOpen = item.classList.contains('Header-navItem--open');
  
  document.querySelectorAll('.Header-navItem--open').forEach(openItem => {
    if (openItem !== item) {
      openItem.classList.remove('Header-navItem--open');
    } else {
        if(isOpen){
            item.classList.remove('Header-navItem--open');
        }
    }
  });
  if (!isOpen) {
    item.classList.add('Header-navItem--open');
  } else {
    closeNavIfNeeded();
  }
  updateSubnav();
}

function handleTouchSubNavItemClick(e) {
  // Prevent immediate link navigation on touch devices
  if (e.target.classList.contains('Header-navLink')) {
    e.preventDefault();
  }
}

function initDesktopSubNav() {
  const subNavItems = document.querySelectorAll('.Header-navItem--withSubnav');

  subNavItems.forEach(item => {
    item.removeEventListener('mouseenter', handleDesktopSubNavMouseEnter);
    item.addEventListener('mouseenter', handleDesktopSubNavMouseEnter);
    item.removeEventListener('mouseleave', handleDesktopSubNavMouseLeave);
    item.addEventListener('mouseleave', handleDesktopSubNavMouseLeave);
  });
}

function handleDesktopSubNavMouseEnter() {
  const item = this;
  const isOpen = item.classList.contains('Header-navItem--open');
  if (isOpen) return;
  document.querySelectorAll('.Header-navItem--open').forEach(openItem => {
    openItem.classList.remove('Header-navItem--open');
  });
  item.classList.add('Header-navItem--open');
  updateSubnav();
}

function handleDesktopSubNavMouseLeave() {
  const item = this;
  const isOpen = item.classList.contains('Header-navItem--open');
  if (!isOpen) return;
  item.classList.remove('Header-navItem--open');
  updateSubnav();
  closeNavIfNeeded();
}

function initSubNavDetail() {
  const subNavLinks = document.querySelectorAll('.Header-subNavLink');

  subNavLinks.forEach(link => {
    const detail = link.nextElementSibling;

    link.removeEventListener('mouseenter', handleSubNavLinkMouseEnter);
    link.addEventListener('mouseenter', () => handleSubNavLinkMouseEnter(link, detail));
    link.removeEventListener('mouseleave', handleSubNavLinkMouseLeave);
    link.addEventListener('mouseleave', handleSubNavLinkMouseLeave);

    if (detail && detail.classList.contains('Header-subNavItemDetail')) {
      detail.removeEventListener('mouseenter', handleSubNavDetailMouseEnter);
      detail.addEventListener('mouseenter', handleSubNavDetailMouseEnter);
      detail.removeEventListener('mouseleave', handleSubNavDetailMouseLeave);
      detail.addEventListener('mouseleave', handleSubNavDetailMouseLeave);
    }
  });
}

function handleSubNavLinkMouseEnter(link, detail) {
  if (breakpoint !== 'desktop') return;
  if (updateDetailsTimeout) clearTimeout(updateDetailsTimeout);
  document.querySelectorAll('.Header-subNavItemDetail--visible').forEach(visibleDetail => {
    visibleDetail.classList.remove('Header-subNavItemDetail--visible');
  });
  if (detail) {
    detail.classList.add('Header-subNavItemDetail--visible');
  }
  updateDetails();
}

function handleSubNavLinkMouseLeave() {
  updateDetailsTimeout = setTimeout(() => {
    document.querySelectorAll('.Header-subNavItemDetail--visible').forEach(visibleDetail => {
      visibleDetail.classList.remove('Header-subNavItemDetail--visible');
    });
    updateDetails();
  }, 3000);
}

function handleSubNavDetailMouseEnter() {
  if (updateDetailsTimeout) clearTimeout(updateDetailsTimeout);
}

function handleSubNavDetailMouseLeave() {
  updateDetailsTimeout = setTimeout(() => {
    document.querySelectorAll('.Header-subNavItemDetail--visible').forEach(visibleDetail => {
      visibleDetail.classList.remove('Header-subNavItemDetail--visible');
    });
    updateDetails();
  }, 1000);
}

function updateDetails() {
  const details = document.querySelectorAll('.Header-subNavItemDetail');
  details.forEach(detail => {
    const isVisible = detail.classList.contains('Header-subNavItemDetail--visible');
    gsap.to(detail, { opacity: isVisible ? 1 : 0, display: isVisible ? 'flex' : 'none', duration: 0.3 });
  });
}

function initScroll() {
  window.addEventListener('scroll', onScroll);
}

function initResize() {
  resizing = false;
  window.addEventListener('resize', onResize);
//   window.addEventListener('resize', debounce(onResizeEnd, 200));
}

function onResize() {
  resizing = true;
  if (!collapsed) {
    const header = document.querySelector('.Header');
    if (header) {
      gsap.set(header, { width: window.innerWidth });
    }
  }
}

function onResizeEnd() {
  if (collapseTimeline) {
    collapseTimeline.invalidate();
  }
  resizing = false;
}

function onScroll() {
  if (resizing) return;

  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  let scrollDirection = 'down';
  let thresholdMet = false;

  if (scrollTop < prevScroll) scrollDirection = 'up';
  if (scrollTop > 100) thresholdMet = true;

  if (scrollDirection === 'up' && scrollTop < 100) {
    expandNav();
  } else if (scrollDirection === 'up' &&
    breakpoint !== 'desktop' &&
    shouldExpand({ scrollTop })) {
    expandNav();
  } else if (collapsed === false &&
    breakpoint === 'desktop' &&
    thresholdMet) {
    collapseNav();
  }

  if (scrollDirection === 'down' && thresholdMet) {
    collapseNav();
  }

  updateNavTheme(scrollTop);

  prevScroll = scrollTop;
}

function shouldExpand({ scrollTop }) {
  let shouldExpand = true;
  let activeSection = null;

  document.querySelectorAll('[data-nav-no-expand]').forEach(el => {
    if (activeSection) return;
    const { top, bottom } = el.getBoundingClientRect();
    const active = top <= 0 && bottom > 0;
    if (active) {
      shouldExpand = false;
    }
  });

  return shouldExpand;
}

function updateSubnav() {
  // Ensure details can contribute to calculated height
  document.querySelectorAll('.Header-subNavItemDetail').forEach(detail => {
    detail.removeAttribute('style');
  });

  document.querySelectorAll('.Header-navItem--withSubnav').forEach(item => {
    const isOpen = item.classList.contains('Header-navItem--open');
    const subNav = item.querySelector('.Header-subNav');
    if (subNav) {
      if (isOpen) {
        subNav.style.maxHeight = subNav.scrollHeight + 'px';
        openNavIfNeeded();
      } else {
        subNav.style.maxHeight = null;
      }
    }
  });
}

function showActiveSubNav() {
  const nav = document.querySelector('.Header-nav');
  const navItems = nav ? nav.querySelectorAll('.Header-navItem') : [];
  let detailOffset = nav ? nav.offsetWidth : 0;
  if (navItems.length > 0 && navItems[navItems.length - 1]) {
    detailOffset -= navItems[navItems.length - 1].offsetWidth;
  }

  document.querySelectorAll('.Header-navItem--withSubnav').forEach(item => {
    const isOpen = item.classList.contains('Header-navItem--open');
    const subNav = item.querySelector('.Header-subNav');
    if (subNav) {
      gsap.to(subNav, {
        opacity: isOpen ? 1 : 0,
        duration: 0.3,
        ease: 'expo.out'
      });
    }

    const details = item.querySelectorAll('.Header-subNavItemDetail');
    details.forEach(detail => {
      detail.style.opacity = 0;
      detail.style.left = `${detailOffset}px`;
      detail.style.display = 'none';
    });
  });
}

function closeAllSubNavs() {
  document.querySelectorAll('.Header-navItem--open').forEach(item => {
    item.classList.remove('Header-navItem--open');
  });
  updateSubnav();
}

function expandNav() {
  if (!collapsed) return;
  collapsed = false;

  if (breakpoint === 'desktop') {
    if (collapseTimeline) {
      collapseTimeline.pause();
      collapseTimeline.invalidate();
    }
    if (expandTimeline) {
      expandTimeline.play(0);
    }
    return;
  }

  const header = document.querySelector('.Header');
  if (header) {
    header.classList.remove('Header--hidden');
  }
}

function collapseNav() {
  if (collapsed) return;
  collapsed = true;

  if (breakpoint === 'desktop') {
    closeNav();
    if (expandTimeline) {
      expandTimeline.pause();
      expandTimeline.invalidate();
    }
    if (collapseTimeline) {
      collapseTimeline.play(0);
    }
    const header = document.querySelector('.Header');
    if (header) {
      header.setAttribute('data-open', 'false');
    }
    return;
  } else {
    closeNav();
  }

  const header = document.querySelector('.Header');
  if (header) {
    header.classList.add('Header--hidden');
  }
}

function openNavIfNeeded() {
  if (breakpoint !== 'desktop') return;
  openNav();
}

function closeNavIfNeeded() {
  if (breakpoint !== 'desktop') return;
  closeNav();
}

function openNav() {
  const header = document.querySelector('.Header');
  if(header){
    header.setAttribute('data-open', 'true');
  }
  const nav = document.querySelector('.Header-nav');
  const navSpacer = document.querySelector('.Header-navSpacer');
  const button = document.querySelector('.Header-mobileFooterButton');


  if (breakpoint === 'desktop' && navSpacer) {
    const height = nav ? nav.scrollHeight : 0;
    gsap.to(navSpacer, {
      height: `${height}px`,
      duration: 0.3,
      ease: 'power4.inOut',
      onComplete: () => {
        showActiveSubNav();
      }
    });
  } else if (breakpoint === 'tablet' && nav) {
    const height = nav.scrollHeight;
    gsap.to(nav, {
      maxHeight: `${height}px`,
      duration: 0.3,
      ease: 'power4.inOut',
      onComplete: () => {
        gsap.set(nav, { maxHeight: '100%' });
      }
    });
  } else if (nav && button) {
    let height = window.innerHeight;
    const headerElement = document.querySelector('.Header-a');
    height -= headerElement ? headerElement.offsetHeight : 0;
    height -= 32; // Padding, margin
    height -= 52; // Button
    // window.bodyScrollLock.lock(nav);
    gsap.to(button, {
      opacity: 1,
      display: 'flex',
      duration: 0.3,
      ease: 'power4.inOut'
    });
    gsap.to(nav, {
      height: `${height}px`,
      maxHeight: `${height}px`,
      duration: 0.3 / 2,
      onComplete: () => {
        gsap.set(nav, { maxHeight: '100%' });
      }
    });
  }

  openToggle();
}

function closeNav() {
  const header = document.querySelector('.Header');
  if (header) {
    header.setAttribute('data-open', 'false');
  }
  const nav = document.querySelector('.Header-nav');
  const navSpacer = document.querySelector('.Header-navSpacer');
  const button = document.querySelector('.Header-mobileFooterButton');

  if (header) {
    header.classList.remove('Header--hidden');
  }

  if (breakpoint === 'desktop' && navSpacer) {
    gsap.to(navSpacer, {
      height: 0,
      duration: 0.3,
      ease: 'power4.inOut'
    });
  } else if (breakpoint === 'tablet' && nav) {
    const height = nav.scrollHeight;
    gsap.set(nav, { maxHeight: `${height}px` });
    gsap.to(nav, {
      maxHeight: 0,
      duration: 0.3,
      ease: 'power4.inOut'
    });
  } else if (nav && button) {
    // window.bodyScrollLock.unlock(nav);
    const height = nav.scrollHeight;
    gsap.set(nav, { maxHeight: `${height}px` });
    gsap.to(nav, {
      maxHeight: 0,
      height: 0,
      duration: 0.3,
      ease: 'power4.inOut'
    });
    gsap.to(button, {
      opacity: 0,
      display: 'none',
      duration: 0.3 / 2
    });
  }

  closeAllSubNavs();
  closeToggle();
}

function openToggle() {
  const toggle = document.querySelector('[data-toggle-nav]');
  const toggleText = toggle ? toggle.querySelector('.Button-text') : null;
  const toggleIcon = toggle ? toggle.querySelector('.Button-icon') : null;
  if (toggleText) {
    toggleText.textContent = 'Close';
  }
  if (toggle) {
    toggle.classList.add('Button--beige');
  }
  if (toggleIcon) {
    gsap.to(toggleIcon, { rotate: -45, duration: 0.1 });
  }
}

function closeToggle() {
  const toggle = document.querySelector('[data-toggle-nav]');
  const toggleText = toggle ? toggle.querySelector('.Button-text') : null;
  const toggleIcon = toggle ? toggle.querySelector('.Button-icon') : null;
  if (toggle) {
    toggle.classList.remove('Button--beige');
  }
  if (toggleText) {
    toggleText.textContent = 'Menu';
  }
  if (toggleIcon) {
    gsap.to(toggleIcon, { rotate: 0, duration: 0.1 });
  }
}

function updateNavTheme(scrollTop) {
  let activeSection = null;

  document.querySelectorAll('[data-nav-theme]').forEach(el => {
    const { top, bottom } = el.getBoundingClientRect();
    const active = top <= 0 && bottom > 0;
    if (active) {
      activeSection = el;
    }
  });

  let theme = null;

  if (activeSection) {
    theme = activeSection.getAttribute('data-nav-theme');
  }

  if (theme && theme !== activeNavTheme) {
    activeNavTheme = theme;
    const header = document.querySelector('.Header');
    if (header) {
      header.setAttribute('data-theme', theme);
    }
  }
}

